/* NoaPure product page scripts */
(function () {
  'use strict';

  function initGallery(root) {
    var gallery = root.querySelector('[data-np-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-np-track]');
    var slides = gallery.querySelectorAll('[data-np-slide]');
    var thumbs = gallery.querySelectorAll('[data-np-thumb]');
    var dots = gallery.querySelectorAll('[data-np-dot]');
    if (!track || slides.length < 2) return;
    var current = 0;

    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.dataset.npThumb, 10)); });
    });
    var prev = gallery.querySelector('[data-np-prev]');
    var next = gallery.querySelector('[data-np-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) setActive(i);
        ticking = false;
      });
    }, { passive: true });
  }

  function initBuyBox(root) {
    var radios = root.querySelectorAll('input[type="radio"][name^="np-bundle"]');
    var atcs = root.querySelectorAll('[data-np-atc]');
    var priceEls = root.querySelectorAll('[data-np-atc-price]');
    var labelEls = root.querySelectorAll('[data-np-sticky-label]');
    var errorEl = root.querySelector('[data-np-error]');

    function selected() {
      return root.querySelector('input[type="radio"][name^="np-bundle"]:checked');
    }
    function update() {
      var r = selected();
      root.querySelectorAll('.np-bundle').forEach(function (c) {
        c.classList.toggle('is-selected', !!r && c.contains(r));
      });
      if (!r) {
        atcs.forEach(function (b) { b.disabled = true; });
        return;
      }
      priceEls.forEach(function (e) { e.textContent = r.dataset.price; }); var npVf = root.querySelector('[data-np-form-variant]'); if (npVf) { npVf.value = r.dataset.variantId; } var npQf = root.querySelector('[data-np-form-qty]'); if (npQf) { npQf.value = r.dataset.qty; }
      labelEls.forEach(function (e) { e.textContent = r.dataset.label; });
      var available = r.dataset.available === 'true';
      atcs.forEach(function (b) {
        b.disabled = !available;
        var t = b.querySelector('[data-np-atc-text]');
        if (t) t.textContent = available ? b.dataset.textAdd : b.dataset.textSoldout;
      });
    }
    radios.forEach(function (r) { r.addEventListener('change', update); });
    update();

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.classList.toggle('is-visible', !!msg);
    }

    function addToCart(btn) {
      var r = selected();
      if (!r || r.dataset.available !== 'true') return;
      showError('');
      atcs.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });

      var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var drawer = document.querySelector('cart-drawer');
      var body = { items: [{ id: Number(r.dataset.variantId), quantity: Number(r.dataset.qty) }] };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }

      fetch(root_url + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          var data = result.data;
          if (!result.ok || data.status) {
            showError(data.description || data.message || 'Ürün sepete eklenemedi. Lütfen tekrar deneyin.');
            return;
          }
          if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(data);
          } else {
            window.location.href = root_url + 'cart';
          }
        })
        .catch(function () {
          showError('Bağlantı hatası. Lütfen tekrar deneyin.');
        })
        .finally(function () {
          atcs.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
        });
    }
    atcs.forEach(function (b) { b.addEventListener('click', function (ev) { ev.preventDefault(); addToCart(b); }); }); var npPf = root.querySelector('.np-product-form'); if (npPf) { npPf.addEventListener('submit', function (ev) { ev.preventDefault(); }); }

    // Mobil sabit buton: ana buton görünümden çıkınca göster
    var sticky = root.querySelector('[data-np-sticky]');
    var mainAtc = root.querySelector('[data-np-main-atc]');
    if (sticky && mainAtc) {
      var stickyBtn = sticky.querySelector('button');
      var pending = false;
      var check = function () {
        pending = false;
        var show = mainAtc.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      };
      var schedule = function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(check);
      };
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      check();
    }
  }

  function initBeforeAfter(scope) {
    (scope || document).querySelectorAll('[data-np-ba]').forEach(function (el) {
      if (el.dataset.npReady) return;
      el.dataset.npReady = '1';
      var range = el.querySelector('input[type="range"]');
      if (!range) return;
      var set = function () { el.style.setProperty('--pos', range.value + '%'); };
      range.addEventListener('input', set);
      set();
    });
  }

  function init() {
    document.querySelectorAll('[data-np-main]').forEach(function (root) {
      if (root.dataset.npReady) return;
      root.dataset.npReady = '1';
      initGallery(root);
      initBuyBox(root);
    });
    initBeforeAfter(document);
  }

  window.NoaPure = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
